import z from "zod";
import { numberOperatorSchema, stringOperatorSchema } from "../operations/operation-filter";

export const filterRateSchema = z.object({
  name: stringOperatorSchema.optional(),
  price: numberOperatorSchema.optional(),
  credit: numberOperatorSchema.optional(),
});

export type FilterRateType = z.infer<typeof filterRateSchema>;
